import Toggle, { FormToggle } from './toggle';

export { FormToggle };

export default Toggle;
